import React from "react"
import { Link } from "react-router-dom"

import CatchCard from "~/library/CatchCard"

import * as Yup from "yup"
import { Field } from "formik"
import FormikWrapper from "~/library/FormikWrapper"
import FormikInput from "~/library/FormikInput"
import Area from "~/types/Area"

const areaSchema = Yup.object({
  name: Yup.string().required("A name is required"),
  capacity: Yup.number().required("A capacity is required"),
  description: Yup.string().max(600, "Description must be less than 600 characters"),
})

interface AreaFormProps {
  onSubmit: (values: any) => void
  initialValues?: Area | null
  isEditing?: boolean
}

const AreaForm: React.FC<AreaFormProps> = ({ onSubmit, initialValues, isEditing = false }) => {
  const defaultValues = {
    name: "",
    capacity: "",
    description: "",
    bookable: true,
  }

  const formInitialValues = isEditing && initialValues ? initialValues : defaultValues

  return (
    <FormikWrapper
      onSubmit={onSubmit}
      initialValues={formInitialValues}
      validationSchema={areaSchema}
    >
      <CatchCard>
        <FormikInput name="name" label="Area Name" placeholder="Suite 7" helpText="" />
        <FormikInput
          name="capacity"
          label="Capacity (in People)"
          placeholder="8"
          type="number"
          helpText=""
        />
        <FormikInput name="description" label="Area Description" helpText="" />

        <div className="mb-3">
          <Field name="bookable">
            {({ field }: any) => (
              <div className="form-check">
                <input
                  {...field}
                  type="checkbox"
                  className="form-check-input"
                  id="bookable"
                  checked={field.value}
                />
                <label htmlFor="bookable" className="form-check-label">
                  Bookable
                </label>
                <div className="form-text">
                  When disabled, this area will be hidden from public access
                </div>
              </div>
            )}
          </Field>
        </div>
        <div className="pt-2 d-flex">
          <Link to="/areas" className="ms-auto btn btn-secondary me-2">
            Cancel
          </Link>
          <button type="submit" className="btn btn-primary">
            {isEditing ? "Update" : "Submit"}
          </button>
        </div>
      </CatchCard>
    </FormikWrapper>
  )
}

export default AreaForm
